/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'photo-library': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.75 2A1.75 1.75 0 005 3.75v14c0 .966.784 1.75 1.75 1.75h14a1.75 1.75 0 001.75-1.75v-14A1.75 1.75 0 0020.75 2h-14zM6.5 3.75a.25.25 0 01.25-.25h14a.25.25 0 01.25.25v14a.25.25 0 01-.25.25h-14a.25.25 0 01-.25-.25v-14zm9.506 7.362a.75.75 0 00-1.168-.005L13.17 13.16l-1.414-1.293a.75.75 0 00-1.106.103l-2.5 3.33a.75.75 0 001.2.9l2.004-2.669 1.39 1.272a.75.75 0 001.088-.08l1.583-1.948 2.749 3.443a.75.75 0 001.172-.936l-3.33-4.17zM3.5 5.75a.75.75 0 00-1.5 0v14a2.756 2.756 0 002.75 2.75h14a.75.75 0 000-1.5h-14c-.686 0-1.25-.564-1.25-1.25v-14z" _fill="#000"/>'
  }
})
